import { ca } from '@cian/analytics';

interface IAnalyticsProduct {
  id: number;
  position: number;
}

export const trackOtaActionButton = (offerId: number, position: number) => {
  const product: IAnalyticsProduct = {
    id: offerId,
    position,
  };

  ca('eventSite', {
    name: 'oldevent',
    category: 'DailyrentButton',
    action: 'Click',
    label: 'ToCardCheckDates',
    page: {
      pageType: 'Recommendations',
      listingType: 'list',
    },
    products: [product],
  });
};
